import { AnimatePresence, motion } from 'framer-motion';
import './appnoti.scss'
import { useEffect, useState } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useRef } from 'react';
import type { Swiper as SwiperClass } from 'swiper';
import { X } from 'lucide-react';
import { AppNotificationProps } from '../../interface/interfaces';



const AppNotification = ({ toggle, setToggle }: AppNotificationProps) => {

    const [notiType, setNotiType] = useState<string>('all');


    const tabOrder = ['all', 'unread', 'archive'];
    const swiperRef = useRef<SwiperClass | null>(null);
    const appNotiBox = useRef<HTMLDivElement>(null);


    const handleNotiSwitch = (type: string) => {
        setNotiType(type);
        const index = tabOrder.indexOf(type);
        swiperRef.current?.slideTo(index);
    }

    const handleClose = () => {
        setToggle(false)
    }


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggle &&
                appNotiBox.current &&
                !appNotiBox.current.contains(event.target as Node)) {

                setToggle(false)
            }

        }

        swiperRef.current?.slideTo(0);

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [toggle,setToggle]);



    return (
        <AnimatePresence>


            {toggle && (<motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                    type: "tween",
                    duration: 0.2,
                    ease: "linear"  // or "easeIn", "easeOut", "linear"
                }}

                className='appNotiBox'
                ref={appNotiBox}

            >

                <div style={{ overflow: 'hidden', padding: '15px' }}>
                    <div className='closeX' onClick={() => handleClose()}>
                        <X size={16}></X>
                    </div></div>



                <div className='headerFlex'>
                    <div className='title'>Notifications</div>
                    <div className='markr'>Mark All As Read</div>
                </div>

                <div className='menuArea'>


                    <div className='optGrid'>


                        <div className='eachOpt' onClick={() => handleNotiSwitch('all')}>
                            <div className='icon allmessage'></div>
                            <div className='text'>All</div>

                            {notiType === 'all' && (<motion.div
                                layoutId="underline"
                                className="navline"
                                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            ></motion.div>)}

                        </div>

                        <div className='eachOpt' onClick={() => handleNotiSwitch('unread')}>
                            <div className='icon unread'></div>
                            <div className='text'>Unread</div>

                            {notiType === 'unread' && (<motion.div
                                layoutId="underline"
                                className="navline"
                                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            ></motion.div>)}

                        </div>

                        <div className='eachOpt' onClick={() => handleNotiSwitch('archive')}>
                            <div className='icon archive'></div>
                            <div className='text'>Archive</div>

                            {notiType === 'archive' && (<motion.div
                                layoutId="underline"
                                className="navline"
                                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            ></motion.div>)}
                        </div>


                    </div>


                    <div className='icon setting'></div>

                </div>


                <div className='notiContentBox'>

                    <Swiper
                        onSwiper={(swiperInstance: SwiperClass) => {
                            swiperRef.current = swiperInstance;
                        }}
                        onSlideChange={(swiper: SwiperClass) => {
                            setNotiType(tabOrder[swiper.activeIndex]);
                        }}
                        spaceBetween={0}
                        slidesPerView={1}
                    >


                        <SwiperSlide>
                            <div className='notiContents all'>



                                {/* <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv order_shipped'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Order shipped!</div>
                                            <div className='text'>Your order #4356 is on its way! Track your shipment now.</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>



                                    <div className='noticolor green'></div>



                                </div>


                                <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv out_for_delivery'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Out for delivery</div>
                                            <div className='text'>Your package will be delivered today! Get ready.</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>





                                    <div className='noticolor green'></div>



                                </div>



                                <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv flash_sale'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Flash sale</div>
                                            <div className='text'>Up to 50% off for the next 24 hours. Shop now!</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>

                                    <div className='noticolor green'></div>


                                </div>



                                <div className='eachNoti'>

                                    <div className='in_flex'>

                                        <div className='icon'>
                                            <div className='imageDiv bonus'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Referral bonus earned</div>
                                            <div className='text'>Your friend made a purchase, you've earned $5 coupon!</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>





                                    <div className='noticolor green'></div>



                                </div>



                                <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv security'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Security notice</div>
                                            <div className='text'>New login detected. if this wasn't you, reset your password now!</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>





                                    <div className='noticolor green'></div>



                                </div> */}








                            </div>
                        </SwiperSlide>


                        <SwiperSlide>
                            <div className='notiContents unread'>

                                {/* <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv order_shipped'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Order shipped!</div>
                                            <div className='text'>Your order #4356 is on its way! Track your shipment now.</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>



                                    <div className='noticolor green'></div>



                                </div>


                                <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv out_for_delivery'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Out for delivery</div>
                                            <div className='text'>Your package will be delivered today! Get ready.</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>





                                    <div className='noticolor green'></div>



                                </div> */}



                            </div>
                        </SwiperSlide>



                        <SwiperSlide>
                            <div className='notiContents archive'>

                                {/* <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv order_delivered'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Order Delivered!</div>
                                            <div className='text'>Your package has been delivered, we hope you love it!</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>



                                    <div className='noticolor green'></div>



                                </div>


                                <div className='eachNoti'>

                                    <div className='in_flex'>
                                        <div className='icon'>
                                            <div className='imageDiv coupon'></div>
                                        </div>

                                        <div className='content_det'>
                                            <div className='title'>Coupon applied</div>
                                            <div className='text'>You used your referral coupon, keep shopping for more coupons</div>
                                            <div className='time'>9:45 AM</div>
                                        </div>
                                    </div>





                                    <div className='noticolor green'></div>



                                </div> */}

                            </div>
                        </SwiperSlide>


                    </Swiper>




                </div>



            </motion.div>
            )}

        </AnimatePresence>
    )
}


export default AppNotification;